import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetOperationalCAAMetricsTherapistWeekCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: { personaName?: string; date: string }) => {
    return await repository.getOperationalCAAMetricsTherapistWeek(params)
  }
}
